import type { AuthSession } from '../auth/session'

export function operatorAttendantKey(session: AuthSession, serviceConfigId: number): string {
  return `filazero.operatorAttendant.v2:${JSON.stringify([
    session.providerId,
    session.locationId,
    (session.email ?? session.userName ?? '').trim().toLowerCase(),
    serviceConfigId,
  ])}`
}

export function readOperatorAttendant(session: AuthSession, serviceConfigId: number): string | null {
  try {
    return localStorage.getItem(operatorAttendantKey(session, serviceConfigId)) || null
  } catch {
    return null
  }
}

export function writeOperatorAttendant(session: AuthSession, serviceConfigId: number, id: string | null): void {
  try {
    const key = operatorAttendantKey(session, serviceConfigId)
    if (id) { localStorage.setItem(key, id) }
    else { localStorage.removeItem(key) }
  } catch {
    // Storage pode estar indisponível; a seleção continua funcionando nesta sessão.
  }
}
